import React from "react";
import { Grid } from "@mui/material";
/*======================================================================================
                          LSD Item Component.
  This renders a grid of colored boxes based on the the lsdProps and
  maxGroupNumber passed as props. The lsdProps is an array of numbers representing the
  group numbers to be colored. The maxGroupNumber is the maximum number of group numbers
  to be displayed. If maxGroupNumber is not provided, it defaults to 4. The component
  uses the COLORS constant array to assign colors to the group numbers.
  The component uses the Grid component from Material-UI to render the colored boxes.
  
=======================================================================================*/
// Define a constant array of colors
const COLORS = [
    "#008000", // Green
    "#000080", // Dark Blue
    "#0000FF", // Blue
    "#FFA500", // Orange
    "#FFFF00", // Yellow
    "#FF00FF", // Pink
    "#000000", //
    "#FF1493", // Dark Pink
    "#006000", // Green
    "#FF0000", // Red
    "#800000", // Brown
    "#222222", //
    "#800080", // Purple
    "#FF00FF", // 
];
const LsdItem = ({ lsdProps = [], maxGroupNumber = 4 }) => {
    const groupNumbers = Array.from({ length: maxGroupNumber }, (_, i) => i);
    return React.createElement(Grid, { container: true, spacing: 0, direction: "row" }, groupNumbers.map((groupNumber, index) => (React.createElement(Grid, { item: true, xs: 12 / groupNumbers.length, key: index, style: {
            backgroundColor: lsdProps.includes(index)
                ? COLORS[index]
                : "transparent", // Apply background color based on lsdProps
            maxWidth: "100%", // Set max width
            width: "100%", // Ensure the item takes full width available
            height: "28px", // Ensure the item takes full height available
            display: "flex", // Use flexbox to center content
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            border: "1px solid transparent", // Add border
        } }, "\u00A0"))));
};
export default LsdItem;
